import { useUserContext } from "../../context/auth/user.context";
import { NavMenuMobile } from "./navMenu/NavMenuMobile";
import { NavMenuDesktop } from "./navMenu/NavMenuDesktop";
import AuthModal from "../Auth/components/AuthModal";
import { useCartContext } from "../../context/cart.context";
import { MailConfirmationModal } from "../Auth/components/MailConfirmationModal";

export function NavMenu() {
  const { toggleCart } = useCartContext();
  const { user } = useUserContext();

  function handleCartClick() {
    toggleCart();
  }

  return (
    <>
      <NavMenuMobile user={user} handleCartClick={handleCartClick} />
      <NavMenuDesktop user={user} handleCartClick={handleCartClick} />
      <AuthModal />
      <MailConfirmationModal />
    </>
  );
}
